import { Avatar, Button, Flex, List, message, Modal, Space, Tooltip } from 'antd'
import { Dispatch, SetStateAction, useRef, useState } from 'react'
import {
  MdOutlinePlaylistRemove,
  MdPlaylistAdd,
  MdPlaylistAddCheck,
} from 'react-icons/md'

import { HiMiniNoSymbol } from 'react-icons/hi2'
import { MdDelete } from 'react-icons/md'
import { Song } from '../../../utils/redux/songsSlice'
import { useAppDispatch } from '../../../utils/redux/store'
import AllTracksTable from './AllTracksTable'
import EditSongDrawer, { EditSongDrawerMethods } from './EditSongDrawer'

export type ADDING_TRACKS_TO = 'NEW_PLAYLIST' | 'EXIST_PLAYLIST'
export default function AllTracks() {
  const dispatch = useAppDispatch()

  const [selectedSongs, setSelectedSongs] = useState<Song[]>()
  // const [addingTracksTo, setAddingTracksTo] = useState<ADDING_TRACKS_TO|undefined>(undefined)

  const editSongDrawerRef = useRef<EditSongDrawerMethods>(null)
  return (
    <>
      <Space direction="vertical" style={{ flexGrow: 1 }}>
        {/* <Actions setAddingTracksTo={setAddingTracksTo} addingTracksTo={addingTracksTo} selectedSongs={selectedSongs}/> */}
        <AllTracksTable
          onEditSong={(song) => editSongDrawerRef.current?.open(song)}
          setSelectedSongs={setSelectedSongs}
        />
      </Space>
      <EditSongDrawer ref={editSongDrawerRef} />
    </>
  )
}

interface ActionProps {
  setAddingTracksTo: Dispatch<SetStateAction<ADDING_TRACKS_TO | undefined>>
  addingTracksTo: ADDING_TRACKS_TO | undefined
  selectedSongs: Song[]
}

function Actions({ setAddingTracksTo, addingTracksTo, selectedSongs }: ActionProps) {
  return (
    <Flex>
      <Flex gap={10}>
        <Tooltip title="Add to an existing playlist">
          <Button
            onClick={() => setAddingTracksTo('EXIST_PLAYLIST')}
            icon={<MdPlaylistAddCheck />}
            size="small"
          />
        </Tooltip>
        <Tooltip title="Add to the new playlist">
          <Button
            onClick={() => setAddingTracksTo('NEW_PLAYLIST')}
            icon={<MdPlaylistAdd />}
            size="small"
          />
        </Tooltip>

        {addingTracksTo && (
          <Tooltip title="Cancel adding songs">
            <Button
              onClick={() => setAddingTracksTo(undefined)}
              icon={<MdOutlinePlaylistRemove />}
              size="small"
            />
          </Tooltip>
        )}

        <Tooltip title="Delete">
          <Button
            onClick={() => {
              Modal.confirm({
                width: 'auto',
                title: `Are you sure you want to delete this ${selectedSongs.length} songs? `,
                content: (
                  <List
                    size="small"
                    itemLayout="horizontal"
                    dataSource={selectedSongs}
                    renderItem={(song) => (
                      <List.Item>
                        <List.Item.Meta
                          avatar={
                            <Avatar
                              shape="square"
                              src={song.imageUrl}
                              icon={<HiMiniNoSymbol />}
                            />
                          }
                          title={song.title}
                          description={song.artist}
                        />
                      </List.Item>
                    )}
                  />
                ),
                onOk: () => {
                  message.warning('Under development')
                },
              })
            }}
            icon={<MdDelete />}
            size="small"
          />
        </Tooltip>
      </Flex>
    </Flex>
  )
}
